module.exports = __webpack_public_path__ + "static/img/2819_phase_function_Paper_Points.ecdfd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2819_phase_function_Paper_Points.png
// module id = STpA
// module chunks = 0